import { render } from "./HeaderNew.vue?vue&type=template&id=45a1b954&scoped=true&lang=pug"
import script from "./HeaderNew.vue?vue&type=script&lang=js"
export * from "./HeaderNew.vue?vue&type=script&lang=js"

import "./HeaderNew.vue?vue&type=style&index=0&id=45a1b954&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a1b954"]])

export default __exports__